(function ($, window) {
    $(function () {
        if ($('#event-calendar').length > 0 && events) {

          //  events = JSON.parse(events);

            var tooltip = document.querySelector('#tooltip');
            var showEvents = ['mouseenter', 'focus'];
            var hideEvents = ['mouseleave', 'blur'];
            var calendarEl = document.getElementById('event-calendar');
            var calendar = new FullCalendar.Calendar(calendarEl, {
                initialView: 'dayGridMonth',
                locale: 'lt',
                firstDay: 1,
                editable: false,
                navLinks: false,
                fixedWeekCount: false,
                displayEventTime: false,
                allDay: true,
                events: events,
                eventMouseEnter: function (info){
                    tooltip.innerText = info.event.title;
                    var popperInstance = Popper.createPopper(info.el, tooltip, {
                        placement: 'top',
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, 7],
                                },
                            },
                        ]
                    });

                    function show() {
                        tooltip.setAttribute('data-show', '');

                        // We need to tell Popper to update the tooltip position
                        // after we show the tooltip, otherwise it will be incorrect
                        popperInstance.update();
                    }

                    function hide() {
                        tooltip.removeAttribute('data-show');
                    }

                    showEvents.forEach(event => {
                        info.el.addEventListener(event, show);
                    });

                    hideEvents.forEach(event => {
                        info.el.addEventListener(event, hide);
                    });
                }
            });
            if($(window).width() < 768) calendar.setOption('contentHeight', 340);
            calendar.render();
        }
    });
})(jQuery, window);